import { useContext, useEffect } from "react";
import {
  UNSAFE_NavigationContext as NavigationContext,
  useLocation,
} from "react-router-dom";

export function usePrompt(when, message) {
  const navigator = useContext(NavigationContext).navigator;
  const location = useLocation();

  useEffect(() => {
    if (!when) return;

    const originalPush = navigator.push;

    navigator.push = (...args) => {
      let nextLocation;

      if (typeof args[0] === "string") {
        const url = new URL(args[0], window.location.origin);
        nextLocation = {
          pathname: url.pathname,
          search: url.search,
        };
      } else if (typeof args[0] === "object") {
        nextLocation = {
          pathname: args[0].pathname || location.pathname,
          search: args[0].search || "",
        };
      } else {
        nextLocation = {
          pathname: location.pathname,
          search: location.search,
        };
      }

      // ✅ Only prompt if navigating to a *different pathname*
      if (nextLocation.pathname !== location.pathname) {
        const result = window.confirm(message);
        if (!result) return;
      }

      navigator.push = originalPush;
      originalPush(...args);
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [when, message, navigator, location.pathname, location.search]);
}
